// Intersection observer polyfill for IE11
import 'intersection-observer';
// URLSearchParams polyfill for IE11
import 'url-search-params-polyfill';
// IE9, IE10 and IE11 requires all of the following polyfills
import 'core-js/es6/promise';
import 'core-js/es6/object';
import 'core-js/es6/array';
import 'core-js/es6/map';
import 'isomorphic-fetch';
import * as React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { client } from './utils/apollo';

import { getProjectSubDomain, apps } from './utils/routing';
import { setupVersion } from './config';
import { configureStore } from './redux/store/configureStore';

import './footer.css';

import './internet-explorer.css';

const project = getProjectSubDomain();
const store = configureStore();
const SolarApp = apps[project];

const Routes = () => {
  setupVersion();
  return (
    <div id="solar">
      <Provider store={store}>
        <ApolloProvider client={client}>
          <SolarApp />
        </ApolloProvider>
      </Provider>
    </div>
  );
};

// @ts-ignore
const App = __DEV__ ? require('react-hot-loader').hot(module)(Routes) : Routes;

export default App;
